import React, { useState } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Gallery from "../components/Gallery";
import Testimonials from "../components/Testimonials";
import ServiceArea from "../components/ServiceArea";
import Footer from "../components/Footer";
import QuoteWizard from "../components/QuoteWizard";

export default function HomePage() {
  const [wizardOpen, setWizardOpen] = useState(false);
  const open = () => setWizardOpen(true);

  return (
    <div className="bg-[#0D0D0D] min-h-screen text-white">
      <Header onQuoteClick={open} />
      <Hero onQuoteClick={open} />
      <Services onQuoteClick={open} />
      <Gallery />
      <Testimonials />
      <ServiceArea />
      <Footer onQuoteClick={open} />
      <QuoteWizard open={wizardOpen} onOpenChange={setWizardOpen} />
    </div>
  );
}
